<div class="asset-picker">
  <span class="asset-picker-label">SELECT ASSET</span>
  <span class="asset-picker-separator">/</span>

  <div class="asset-picker-item">
    <button class="asset-picker-btn" [class.open]="openMenu === 'template'" (click)="toggleMenu('template')">
      <span class="asset-picker-btn-text">{{ selectedTemplate?.className ?? 'SELECT TEMPLATE' }}</span>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <div class="asset-picker-menu" *ngIf="openMenu === 'template'">
      <ul class="asset-picker-list">
        <li *ngFor="let template of templates" [class.selected]="template.id === selectedTemplate?.id" (click)="selectTemplate(template)">
          {{ template.className }}
        </li>
      </ul>
    </div>
  </div>

  <span class="asset-picker-separator">/</span>

  <div class="asset-picker-item">
    <button class="asset-picker-btn" [class.open]="openMenu === 'substation'" [disabled]="!selectedTemplate" (click)="toggleMenu('substation')">
      <span class="asset-picker-btn-text">{{ selectedSubstation?.name ?? 'SELECT SUBSTATION' }}</span>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <div class="asset-picker-menu" *ngIf="openMenu === 'substation'">
      <div class="asset-picker-search">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6.25" cy="6.25" r="4.25" stroke="currentColor" stroke-width="1.2"/>
          <path d="M9.5 9.5L12.25 12.25" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
        </svg>
        <input type="text" placeholder="Search" [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)" />
      </div>
      <ul class="asset-picker-list">
        <li *ngFor="let substation of substations | slice:0:5"[class.selected]="substation.id === selectedSubstation?.id" (click)="selectSubstation(substation)">
          {{ substation.name }}
        </li>
        <li *ngIf="!substations.length" class="asset-picker-empty">No substations found</li>
      </ul>
    </div>
  </div>
</div>
